import moment from 'moment';

export const getFormattedDate = (
    date,
    { pattern = 'HH:mm, D MMMM YYYY', toLocalDate = false } = {},
) => {
    const momentDate = toLocalDate ? moment.utc(date).local() : moment(date);

    return momentDate.format(pattern);
};
